// Escaping tagged template. Every interpolation is escaped unless it is itself
// an html`` result (or trusted(), which is for constant SVG markup only).
class Safe {
  constructor(text) { this.text = text; }
  toString() { return this.text; }
}
const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
const part = v =>
  v instanceof Safe ? v.text
  : Array.isArray(v) ? v.map(part).join('')
  : v == null || v === false ? ''
  : String(v).replace(/[&<>"']/g, c => ESC[c]);

export const html = (strings, ...values) =>
  new Safe(strings.reduce((out, s, i) => out + part(values[i - 1]) + s));
export const trusted = markup => new Safe(markup);

// One element from a template (the template must have one root element).
export function el(template) {
  const t = document.createElement('template');
  t.innerHTML = String(template).trim();
  return document.adoptNode(t.content.firstElementChild);
}
